import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Project } from '@simultrain/shared';
import { api } from '../api/client.js';

export function ProjectsPage() {
  const { t } = useTranslation();
  const [projects, setProjects] = useState<Project[] | null>(null);

  useEffect(() => {
    void api.listProjects().then(setProjects);
  }, []);

  if (projects === null) return <div className="empty">…</div>;
  if (projects.length === 0) return <div className="empty">{t('projects.empty')}</div>;

  return (
    <div>
      <h2>{t('projects.title')}</h2>
      {projects.map((p) => (
        <Link to={`/projects/${p.id}`} key={p.id} style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="card">
            <h3 style={{ margin: 0 }}>{p.name}</h3>
            <div className="muted">{p.description}</div>
          </div>
        </Link>
      ))}
    </div>
  );
}
